var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Rich',{attrs:{"value":_vm.detail.content}})
}
var staticRenderFns = []

export { render, staticRenderFns }